<template>
    <div class="mod-joylearning__offringlist" >
        <!-- 公司信息 -->
        <div class="pkg-content-top" >
            <el-row class="con" >
                    <div class="info-title" style="text-decoration: none;display:inline-block;  float: left;">{{
                    info.nameCn
                    }}</div>


                    <div type="text"
                    @click="dialogVisible = true"
                    style="display:inline-block; float: right;"
                    >
                    帮助
                    <img alt="" src="data:image/png;base64,iVBORw0KGgoAAAA
                    NSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAAXNSR0IArs4c6QAACJlJR
                    EFUaEPlW32MHGUZ/z2zKBo//jIp3M4SjBhKZ7bnR/0oiimWJtQW+hdSCom2aG9
                    nqQoa/AarhjZGxEroztwhtiZUQE2MUKBJOW2s0h6pgevOSP0MOu9Cz/iHigS03XnM7
                    O3ezufOO3N7V2MnuX92nq/f+77zvM/XEc6yh84yvFhwwGqtuYoULGFPWUKEJQwsAbzzZhdaO
                    UnADDNmSPFm2MOMsKqHFnIThg5YrTsXEeMyZl4DwnoAb8gJ4EUw9hPRQSYcFg3tDzn5B5IPDXCl5
                    mxh8j4O0HuHaSDAR4mVe11L+94w5M4bcKVmb2RCHcBlwzBogIzDxGi4lv7gfPQUBjxSt69SuAP0SikDmAUUcs
                    EQxBA+DxNU+H8eV0CkSskBDniExvMN/RFJ+hBZIcCVmn0bE76WofApAk16CiZbu7VJGePKNzmrFQ+rGbwawLsH8RDj
                    dtfSvy4jN0iTG3DZcB4k8LXJivhlAna18arvP28u/W1eY4L0I8aJi0s49REGbgbotUmyGPRQy9Q25tGTC7Bq2DYALVE5Yy8Yu1r
                    j+nQeA7Joy2P2KAg3E+GjKbSOMHU9S07vvTRg1bA5WShNwTu9XYyPHpBVWoROHZu+Eso52wF+TxK/MHUpLFJEFaN5kEFXxBQx7xNW9YYiAIryq
                    LXm/SC6PspP4Cdcs7omS24m4DQHxcBYy9QnshQkvR/ZeuxNinKu/mrv30//aWLFP/LKKBv2VgLGY6AlHNlAwGXDqRHYjAqWPT49PtU4sRx0+npmLAWwnI
                    ALAzKPE/A0Ex8Wjep9ecAnfWYMMlqmZqXJSQXcvWcfTjjGl+eJd1XD+SaAbQC/JhMM8WPsKd9qWdrPMmkB+HE6iH4epfUIV6fd06mAVcN+PBZUMH9VWNXtMsb
                    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

                    f/9vPLILcaboFnyHzxSwNL3/BXzfBHmIenyzAAAAAElFTkSuQmCC" alt="" style="width:20px;height:20px;cursor:pointer">

                    </div>


            <el-dialog

        :visible.sync="dialogVisible"
        width="800px"

        >
        <div class="logbox" style="height:560px;overflow:auto;padding:10px 10px">
            <h2 style="text-align:center">常见问题</h2>
            <h3>问题1：2022年，预存窗口是什么时间？</h3>
            <p>答：每月5日-15日为预存窗口期。</p>
            <h3 style="margin-top:30px">问题2：预存的培训/辅导资金，什么时候可以到账并用于报名？</h3>
            <p>答：预存次日下午3点后，即可在悦学苑的交易明细页面看到存款到账信息，
                与此同时预存资金可以报名培训/辅导。</p>
            <h3 style="margin-top:30px">问题3：怎样查看所有冻结金额的交易记录？</h3>
            <p>答：查询结果筛选框选择“冻结金额”，可查看所有的冻结金额交易明细。</p>
            <h3 style="margin-top:30px">问题4：报名、撤销、关课会怎样影响冻结金额？</h3>
            <p>答： 学员报名，系统会冻结排期价格，冻结金额会增加；
                撤销报名，系统会解冻报名时的冻结金额，冻结金额会减少；
                关课，即培训师在确认完学员出勤情况/成绩，正式关课后，系统会对课程费用进行结算扣款。
                同时解冻报名时冻结金额，冻结金额会减少。</p>
                <h3 style="margin-top:30px">问题5：课程已经结束，培训/辅导费用什么时候会结算？</h3>
                <p>答： 培训师在确认完学员出勤情况/成绩，正式关课后，课程费用将会结算。</p>
                <h3 style="margin-top:30px">问题6：已经结算的课程费用，什么时候会收到发票？</h3>
                <p>答：发票会在每月最后一个自然日开具，并在开具后5个工作日内寄出。
                    发票号及快递单号生成后均可在培训辅导交易查询页面查看。</p>
                <h3 style="margin-top:30px">问题7：账户余额不足，是否可以报名？</h3>
                <p>答：账户余额不足时，将无法进行报名、分配、替换、审批的系统操作，
                    也将影响本店培训辅导业务的进展。请确保本店培训/辅导费用充足。</p>
        <br>
                <h2 style="text-align:center">系统功能讲解</h2>
                <h3>更多系统功能讲解请登陆悦学苑APP，搜索<培训及辅导付费功能介绍>即可学习。</h3>
        <br>


            <h2 style="text-align:center">预存资金操作流程</h2>
            <h3>1.经销商需通过银行转账的方式，向以下华晨宝马培训专用账户进行付款。</h3>
                <el-table
                    :data="tableData"
                    border
                    :show-header="false"
                    style="width: 100%;">
                    <el-table-column
                    prop="name"
                    width="180">
                    </el-table-column>
                    <el-table-column
                    prop="address">
                    </el-table-column>
                </el-table>


                    <h3>2.转账成功后，经销商需登录DWP系统完成培训资金预存信息的填报。
                        未及时填报信息，将影响报名。</h3>
                    <ul><li>DWP登录账号：经销商在DWP中“零件业务”账号，如：12345PAR</li></ul>
                    <ul>
                        <li style="margin-top:10px">

                            培训资金信息录入：点击：“培训资金预存-培训资金预存录入”录入本次付款日期及付款金额

                        </li>
                    </ul>
                    <ul>
                        <li style="margin-top:10px;list-style:none">
                        <strong>注：如同一付款日期存在多次付款操作，
                            请按照每笔实际付款金额分别录入，
                            不可直接录入合计付款总金额</strong>
                        </li>
                    </ul>
                    <h3>3.培训资金预存状态查询：
                        点击“培训资金预存-培训资金预存状态”可查询付款接收状态及历史记录。</h3>
                        <h4>付款信息状态：见下表</h4>

                    <el-table
                    :data="fukuan"
                    border
                    style="width: 100%">
                    <el-table-column
                    prop="name"
                    label="状态描述"
                        width="180">
                    </el-table-column>
                    <el-table-column
                    prop="address"
                    label="备注">
                    </el-table-column>
                        </el-table>
        <br>


                    <h2 style="text-align:center">费用返还流程</h2>
                    <h3>由于不可预计原因产生了费用返还（上述不可预计原因需符合现行税法开具红字发票范围），
                        将按照此流程执行：培训学院通知经销商费用返还金额。
                        经销商需在接收到通知后5个工作日内根据费用返还金额向华晨宝马开具红字发票信息表，
                        并将电子版红字发票信息表按以下要求发送至指定邮箱，待审核无误后，
                        华晨宝马将向经销商开具红字发票，并将返还金额退还至经销商培训专用资金中。</h3>
                        <ul><li> 红字发票信息表指定接收邮箱：<strong> Redinvoicedealertraining@bmw-brilliance.cn</strong>
        </li>
                        <li style="margin-top:20px"> 邮件标题：红票通知单。
        </li>
                        <li style="margin-top:20px"> 邮件附件格式：红字发票信息表需为 <strong>PDF</strong>格式，每封邮件有且只能包含一个 <strong>PDF</strong> 附件。
        </li></ul>
        </div>
        <span slot="footer" class="dialog-footer">
            <!-- <el-button @click="dialogVisible = false">关闭</el-button> -->
            <!-- <el-button type="primary" @click="dialogVisible = false">确 定</el-button> -->
        </span>
            </el-dialog>

           </el-row>

                    <!-- 账户余额 -->
            <el-row class="pkg-content-row" :gutter="50" >
                <el-col class="content-row-item">
                    <div class="row-item-left">
                        <img alt="" src="../../../../assets/img/learning/Scheduling/system_training_cost_card_icon_balance@1x.png"
                             alt="">
                    </div>
                    <div class="row-item-right" >
                        <div class="row-item-right-title">账户余额</div>
                        <div class="row-item-right-money" style="overflow:hidden">

                            {{ formatMoney(info.accountBalance) }}
                        </div>
                        <div class="row-item-right-tip">当前账户实际金额。</div>
                        <div class="row-item-right-tip">
                            存钱次日可用，结算次日更新。
                        </div>
                    </div>

                </el-col>
                <el-col class="content-row-item">
                    <div class="row-item-left">
                        <img alt="" src="../../../../assets/img/learning/Scheduling/system_training_cost_card_icon_freeze@1x.png"
                             alt="">
                    </div>
                    <div class="row-item-right">
                        <div class="row-item-right-title">冻结金额</div>
                        <div class="row-item-right-money">
                            {{ formatMoney(info.frozenAmount) }}
                        </div>
                        <div class="row-item-right-tip">
                            已报名课程未结算金额。
                        </div>
                        <div class="row-item-right-tip">
                            报名和撤销实时更新，关课次日更新。
                        </div>
                    </div>
                    <!-- <div class="info-sub-titlte">
                      冻结金额
                      <el-tooltip class="item" effect="dark" placement="top">
                        <div slot="content">
                        冻结金额：报名、撤销、关课产生的金额变化汇总<br/>
                        更新时间：报名和撤销报名实时更新；结算每日凌晨6点左右更新<br/>
                        </div>
                        <em class="el-icon-question"></em>
                      </el-tooltip>
                    </div>
                    <span class="info-sub-value">{{ formatMoney(info.frozenAmount) }}</span> -->
                </el-col>
                <el-col class="content-row-item">
                    <div class="row-item-left">
                        <img alt="" src="../../../../assets/img/learning/Scheduling/system_training_cost_card_icon_use@1x.png"
                             alt="">
                    </div>
                    <div class="row-item-right">
                        <div class="row-item-right-title">可用余额</div>
                        <div class="row-item-right-money">
                            {{ formatMoney(info.availableBalance) }}
                        </div>
                        <div class="row-item-right-tip">
                            实际可用于报名的金额
                        </div>
                        <div class="row-item-right-tip">
                            (账户余额 - 冻结金额)。
                        </div>
                    </div>

                    <!-- <div class="info-sub-titlte">
                      可用余额
                      <el-tooltip class="item" effect="dark" content="可用余额：当前实际用于报名的金额（账户余额 - 冻结金额）" placement="top">
                        <em class="el-icon-question"></em>
                      </el-tooltip>
                    </div>
                    <span class="info-sub-value">{{ formatMoney(info.availableBalance) }}</span> -->
                </el-col>
            </el-row>

        </div>
        <!-- 搜索栏 -->
        <div class="pkg-search-box" style="margin-top: 10px">
            <el-form
                    class="pkg-content"
                    label-width="auto"
                    label-position="top"
                    :model="dataForm"
                    ref="dataForm"
                    @keyup.enter.native="getDataList()"

            >
                <el-row class="search-box">
                    <el-col :span="19">
                        <el-row class="margb10">

                            <el-col :span="8">
                                <el-form-item label="查询结果">
                                    <el-select
                                            :disabled="fromDisabled.queryType"
                                            @change="queryTypeChange"
                                            v-model="dataForm.queryType"
                                            :clearable="false"
                                            placeholder="请选择"
                                    >
                                        <el-option
                                                v-for="item in resultTypeList"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>

                            <el-col :span="8">
                                <el-form-item label="课程名称">
                                    <el-input
                                            :disabled="fromDisabled.courseName"
                                            v-model="dataForm.courseName"
                                            placeholder="课程代码/名称"
                                    ></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :span="8">
                                <el-form-item label="交易时间">
                                    <template slot="label">
                                        <label class="el-form-item__label" style="display:flex;align-items:center;">
                                            <span>交易时间</span>
                                            <!-- <img alt="" style="width:14px;height:14px;" src="../../../../assets/img/learning/Scheduling/general_icon_question@1x.png" alt=""> -->

                                            <el-tooltip
                                                    class="item"
                                                    effect="dark"
                                                    content="如需选择此筛选项，请先清空排期开始结束时间。"
                                                    placement="top"
                                                    v-if="this.dataForm.queryType!==3 && recordTimeDisabled"
                                            >
                        <span class="label-tip">
                          如需选择此筛选项，请先清空排期开始结束时间。
                        </span>
                                            </el-tooltip>
                                        </label>
                                    </template>
                                    <!-- <el-tooltip
                                      :disabled="!recordTimeDisabled"
                                      class="item"
                                      effect="dark"
                                      content="请先清空排期开始/结束时间"
                                      placement="top"
                                    > -->
                                    <el-date-picker
                                            prefix-icon="el-icon-date"
                                            popper-class="date-style-rfq"
                                            :disabled="recordTimeDisabled"
                                            v-model="recordTime"
                                            @change="recordTimeChange"
                                            type="datetimerange"
                                            value-format="yyyy-MM-dd"
                                            format="yyyy-MM-dd"
                                            min-width="300px"
                                            range-separator="-"
                                            style="width: 100%"
                                            :picker-options="pickerOptions"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期"
                                    >
                                    </el-date-picker>
                                    <!-- </el-tooltip> -->
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row class="margb10">
                            <el-col :span="8">
                                <el-form-item label="排期开始时间">
                                    <template slot="label">
                                        <label class="el-form-item__label" style="display:flex;align-items:center;">
                                            <span>排期开始时间</span>



                                            <el-tooltip
                                                    class="item"
                                                    effect="dark"
                                                    content="如需选择此筛选项，请先清空交易时间。"
                                                    placement="top"
                                                    v-if="this.dataForm.queryType!==1 && trainingDateDisabeld"
                                            >
                                                    <span class="label-tip">
                                                        如需选择此筛选项，请先清空交易时间。
                                                    </span>
                                            </el-tooltip>
                                        </label>
                                    </template>
                                    <!-- <el-tooltip
                                      :disabled="!trainingDateDisabeld"
                                      class="item"
                                      effect="dark"
                                      content="请先清空交易时间"
                                      placement="top"
                                    > -->
                                    <el-date-picker
                                            prefix-icon="el-icon-date"
                                            popper-class="date-style-rfq"
                                            :disabled="trainingDateDisabeld"
                                            v-model="trainingStartDate"
                                            @change="trainingStartDateChange"
                                            type="datetimerange"
                                            value-format="yyyy-MM-dd"
                                            format="yyyy-MM-dd"
                                            range-separator="-"
                                            style="width: 100%"
                                            :picker-options="pickerOptions"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期"
                                    >
                                    </el-date-picker>
                                    <!-- </el-tooltip> -->
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="排期结束时间">
                                    <template slot="label">
                                        <label class="el-form-item__label" style="display:flex;align-items:center;">
                                            <span>排期结束时间</span>
                                            <el-tooltip
                                                    class="item"
                                                    effect="dark"
                                                    content="如需选择此筛选项，请先清空交易时间。"
                                                    v-if="this.dataForm.queryType!==1 && dataForm.recordTimeS"
                                                    placement="top"
                                            >
                                                <span class="label-tip"
                                                >如需选择此筛选项，请先清空交易时间。
                                                </span>
                                            </el-tooltip>
                                        </label>
                                    </template>
                                    <!-- <el-tooltip
                                      :disabled="!trainingDateDisabeld"
                                      class="item"
                                      effect="dark"
                                      content="请先清空交易时间"
                                      placement="top"
                                    > -->
                                    <el-date-picker
                                            prefix-icon="el-icon-date"
                                            popper-class="date-style-rfq"
                                            :disabled="trainingDateDisabeld"
                                            v-model="trainingEndDate"
                                            @change="trainingEndDateChange"
                                            type="datetimerange"
                                            value-format="yyyy-MM-dd"
                                            format="yyyy-MM-dd"
                                            range-separator="-"
                                            style="width: 100%"
                                            :picker-options="pickerOptions"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期"
                                    >
                                    </el-date-picker>
                                    <!-- </el-tooltip> -->
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="排期编号">
                                    <el-input
                                            :disabled="fromDisabled.offeringNo"
                                            v-model="dataForm.offeringNo"
                                            :placeholder="$t('请输入')"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row v-if="isOpen" class="margb10">
                            <el-col :span="8">
                                <el-form-item label="所属组织">
                                    <el-select
                                            :disabled="fromDisabled.bizOrgCode"
                                            v-model="dataForm.bizOrgCode"
                                            :clearable="false"
                                            placeholder="请选择"
                                    >
                                        <el-option
                                                v-for="item in organizationList"
                                                :key="item.orgCode"
                                                :label="item.nameCn"
                                                :value="item.orgCode"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="姓名">
                                    <el-input
                                            :disabled="fromDisabled.userKey"
                                            v-model="dataForm.userKey"
                                            :placeholder="$t('姓名/用户ID/员工号')"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="开票月份">
                                    <el-date-picker
                                            prefix-icon="el-icon-date"
                                            :disabled="fromDisabled.invoiceMonth"
                                            v-model="dataForm.invoiceMonth"
                                            type="month"
                                            value-format="yyyyMM"
                                            format="yyyyMM"
                                            style="width: 100%"
                                            placeholder="选择日期"
                                    >
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :span="5">
                        <div @click="isOpen=!isOpen" class="toggle-btn">
                            <span style="color:rgba(28, 105, 212, 100);">{{isOpen?'收起':'高级搜索'}}</span>
                            <img alt="" v-if="isOpen" style="width:8px;height:4px;margin-left:8px;"
                                 src="../../../../assets/img/learning/Scheduling/search_icon_up@1x.png" alt="">
                            <img alt="" v-else style="width:8px;height:4px;margin-left:8px;"
                                 src="../../../../assets/img/learning/Scheduling/search_icon_down@1x.png" alt="">
                        </div>
                        <!-- <ToggleDiv  @toggle="openAction"></ToggleDiv> -->
                    </el-col>

                    <el-row class="search-btn">
                        <el-col :span="24">
                            <el-button class="el-back info-btn" type="info" @click="again"
                            >{{ $t("reset") }}
                            </el-button>

                            <el-button
                                    class="primary-btn"
                                    type="primary"
                                    @click="getDataListMerge"
                            >{{ $t("course.query") }}
                            </el-button>
                        </el-col>
                    </el-row>
                </el-row>
            </el-form>
        </div>

        <!-- action row -->
        <div style="padding-top: 0px">

            <div class="action" style="height:60px">

                <div class="action-left"   v-html="totalValue"  style="margin-top:40px">
                </div>

                <div class="action-right" style="display:flex;margin-left:-100px;margin-top:-30px;margin-right:25px">
                    <!-- <div class="action-right" style="display:flex;margin-left:-180px;margin-top:-30px"> -->
                    <el-button class="info-btn btnColorBlack" type="info" @click="goback">
                        {{ $t("user.back") }}
                    </el-button>
                    <el-button class="primary-btn" type="primary" @click="exportPost" style="width:78px">
                       <span style="margin-left:-14px"> 导出明细</span>
                    </el-button>
                </div>

            </div>

            <el-table
                    v-if="tableShow"
                    v-loading="dataListLoading"
                    ref="multipleTable"
                    :data="dataList"
                    :row-style="{ height: 48 + 'px' }"
            >
                <el-table-column
                        type="index"
                        label="序号"
                        header-align="center"
                        width="50"
                >
                    <!-- <template slot-scope="scope">
                                  <div :style="{'text-align': scope.$index > 0 ? 'center': 'left'}">
                                      <span v-if="scope.$index === 0" style="font-weight: normal;">查询统计：</span>
                                      {{scope.$index > 0 ? scope.$index:totalValue}}
                                  </div>
                              </template> -->
                </el-table-column>
                <el-table-column
                        v-for="(item, i) in tableShowTitles"
                        :key="i"
                        :prop="item.prop"
                        :label="item.label"
                        header-align="center"
                        :align="item.align"
                        :min-width="item.width"
                        :show-overflow-tooltip="true"
                        :formatter="
            (row) => {
              if (item.formatter) {
                return item.formatter(row[item.prop]);
              } else {
                return row[item.prop];
              }
            }
          "
                >
                    <template slot="header" slot-scope="scope">
                        <div style="line-height: 1.15; display: block">
                            {{ item.label }}
                            <el-tooltip
                                    v-if="item.headertooltip"
                                    class="item"
                                    effect="dark"
                                    placement="top"
                            >
                                <div slot="content">
                  <span v-if="item.headertooltip">
                    {{ item.headertooltip }}
                  </span>
                                    <span v-if="item.headertooltip2">
                    <br/>{{ item.headertooltip2 }}
                  </span>
                                </div>
                                <img alt="" style="width:14px;height:14px;"
                                     src="../../../../assets/img/learning/Scheduling/general_icon_question@1x.png"
                                     alt="">
                                <!-- <em class="el-icon-question"></em> -->
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <span style="float: left;line-height: 36px;height: 36px;color: #252628;font-size: 14px;font-family: BMWGlobalProReg, sans-serif;"><strong>所有金额为含税金额(人民币元)</strong> </span>

                <el-pagination
                        :current-page="page"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="limit"
                        :total="total"
                        layout="total, sizes, prev, pager, next, jumper"
                        @size-change="pageSizeChangeHandle"
                        @current-change="pageCurrentChangeHandle"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    import mixinViewModule from "@/mixins/view-module";
    import ToggleDiv from "@/components/toggle-div";
    import Vue from "vue";

    export default {
        mixins: [mixinViewModule],
        name: "RainingFeeQueryView",
        components: {
            ToggleDiv,
        },
        created() {
            this.init();
            this.$eventHub.$on("RainingFeeQueryView", (data) => {
                this.init();
            });
        },
        destroyed() {
            this.$eventHub.$off("RainingFeeQueryView");
        },
        data() {
            return {

                  dialogVisible: false,

                    tableData: [{

                        name: '开户名称',
                        address: '华晨宝马汽车有限公司'
                    },{

                        name: '开户行',
                        address: '交通银行沈阳大东支行'
                        }, {

                        name: '开户行行号',
                        address: '301221000095'
                        }, {

                        name: '账号',
                        address: '211111206018010143940'
                        },],
                        fukuan: [{

                        name: '提交(SUB)',
                        address: '付款信息已提交'
                        }, {

                        name: '确认(CON)',
                        address: '项款已收到'
                        }, {

                        name: '取消(CAN)',
                        address: '若提交信息有误,可自行取消此笔记录'
                        },{

                        name: '拒绝(REJ)',
                        address: '付款信息匹配有误,请参考拒绝原因或联系BBA会计邮Yan.Ke.jb@bmw-brilliance.cn'
                        },]   ,





                mixinViewModuleOptions: {
                    getDataListURL: "/finance/financeaccountrecord/pagecustom",
                    activatedIsNeed: false,
                    getDataListIsPage: true,
                    exportURL: "/finance/financeaccountrecord/export",
                },
                tableShow: true,
                info: {
                    id: "",
                    accountBalance: "", // 账户余额
                    frozenAmount: "", // 已报名冻结金额
                    availableBalance: "", // 可用余额
                    nameCn: "", // 公司名
                },
                pickDate: {}, // 选中的时间
                pickerOptions: {
                    onPick: this.getPickDate,
                    // disabledDate: this.disabledDate,
                }, // 时间选择器选项
                recordTime: "", // 交易时间
                trainingStartDate: null, // 排期开始时间
                trainingEndDate: null, // 排期结束时间
                dataForm: {
                    accountId: "",
                    offeringNo: "", // 排期编号
                    queryType: 0, // 结果类型
                    courseName: "", // 课程名称
                    recordTimeS: "", //交易时间开始
                    recordTimeE: "", //交易时间结束
                    trainingStartDateS: "", // 排期开始时间开始
                    trainingStartDateE: "", // 排期开始时间结束
                    trainingEndDateS: "", // 排期结束时间开始
                    trainingEndDateE: "", // 排期结束时间结束
                    bizOrgCode: "", // 组织
                    invoiceMonth: "", // 开票月份
                    userKey: "", //姓名/用户ID/员工号
                    exportType: "",
                },
                dataList: [],
                isOpen: false,
                totalValue: "", // 合计
                // 查询条件是否可用
                fromDisabled: {
                    offeringNo: false,
                    courseName: false,
                    recordTime: false,
                    trainingStartDate: false,
                    trainingEndDate: false,
                    bizOrgCode: false,
                    invoiceMonth: false,
                    userKey: false,
                },
                // 网格所有列
                tableTitles: {
                    transactionTime: {
                        label: "交易时间",
                        prop: "recordTime",
                        width: "160",
                        align: "center",
                    },

                    // abstract: {
                    //   label: '交易类型',
                    //   prop: 'summarySimple',
                    //   width: '150',
                    //   align: 'left'
                    // },
                    abstract: {
                        label: "摘要",
                        prop: "summary",
                        width: "300",
                        align: "left",
                    },
                    /* trainingStatus: {
                        label: '产生交易时状态',
                        prop: 'trainingStatus',
                        width: '180',
                        formatter: this.statusFormatter,
                        align: 'center',
                        headertooltip: '产生交易时状态：产生交易时间点对应的培训记录状态',
                        headertooltip2: '更新时间：报名和撤销报名实时更新；结算每日凌晨6点左右更新'
                    }, */
                    fundStorage: {
                        label: "资金存储",
                        prop: "storageBalance",
                        width: "120",
                        align: "right",
                        formatter: this.formatMoney,
                        headertooltip: "资金存储：存入账户金额",
                    },
                    costSettlement: {
                        label: "结算费用",
                        prop: "settlementBalance",
                        width: "120",
                        align: "right",
                        formatter: this.formatMoney,
                        headertooltip: "结算费用：课程结束，老师已关课且完成结算的费用",
                    },
                    settlementAmount: {
                        label: "冻结金额",
                        prop: "frozenAmount",
                        width: "120",
                        align: "right",
                        formatter: this.formatMoney,
                        headertooltip: "冻结金额：报名、撤销、关课产生的金额变化汇总",
                        headertooltip2:
                            "更新时间：报名和撤销报名实时更新；结算每日凌晨6点左右更新",
                    },
                    refund: {
                        label: "退款中金额",
                        prop: "refundingAmount",
                        width: "130",
                        align: "right",
                        formatter: this.formatMoney,
                        headertooltip:
                            "退款中金额：如果出现退款中金额，说明有培训状态修改或价格变更情况出现",
                    },
                    balance: {
                        label: "账户余额",
                        prop: "currentBalance",
                        width: "120",
                        align: "right",
                        formatter: this.formatMoney,
                        headertooltip: "账户余额：当前账户实际金额",
                        headertooltip2:
                            "更新时间：存钱每日下午3点左右更新；结算每日凌晨6点左右更新",
                    },
                    billingMonth: {
                        label: "开票月份",
                        prop: "invoiceMonth",
                        width: "100",
                        align: "center",
                    },
                    invoiceNo: {
                        label: "发票号",
                        prop: "invoiceNo",
                        width: "150",
                        align: "center",
                    },
                    courierNumber: {
                        label: "快递单号",
                        prop: "expressInvoiceNo",
                        width: "140",
                        align: "center",
                        headertooltip: "顺丰快递",
                    },
                    courseCode: {
                        label: "课程代码",
                        prop: "courseCode",
                        width: "150",
                        align: "center",
                    },
                    offeringNo: {
                        label: "排期编号",
                        prop: "offeringNo",
                        width: "150",
                        align: "center",
                    },

                    trainingStatus: {
                        label: "产生交易时状态",
                        prop: "trainingStatus",
                        width: "180",
                        formatter: this.statusFormatter,
                        align: "center",
                        headertooltip: "产生交易时状态：产生交易时间点对应的培训记录状态",
                        headertooltip2:
                            "更新时间：报名和撤销报名实时更新；结算每日凌晨6点左右更新",
                    },
                    organization: {
                        label: "产生交易时所属组织",
                        prop: "bizOrgName",
                        width: "280",
                        align: "center",
                    },
                },
                organizationList: [],
                resultTypeList: [
                    {
                        label: "全部",
                        value: 0,
                    },
                    {
                        label: "资金存储",
                        value: 1,
                    },
                    {
                        label: "结算费用",
                        value: 2,
                    },
                    {
                        label: "冻结金额",
                        value: 3,
                    },
                    {
                        label: "退款中金额",
                        value: 6,
                    },
                    {
                        label: "已开具发票金额",
                        value: 4,
                    },
                    {
                        label: "未开具发票金额",
                        value: 5,
                    },
                ],
            };
        },
        computed: {
            // 交易时间是否禁用
            recordTimeDisabled() {
                return (
                    this.fromDisabled.recordTime ||
                    (this.trainingStartDate != null && this.trainingStartDate.length > 1) ||
                    (this.trainingEndDate != null && this.trainingEndDate.length > 1)
                );
            },
            // 排期时间是否禁用
            trainingDateDisabeld() {
                return (
                    this.fromDisabled.trainingStartDate ||
                    (this.recordTime != null && this.recordTime.length > 1)
                );
            },
            showTableList() {
                return [{}, ...this.dataList];
            },
            tableShowTitles() {
                if (this.dataForm.queryType > 0) {
                    let keys = [
                        ["transactionTime", "abstract", "fundStorage", "organization"],
                        [
                            "transactionTime",
                            "abstract",
                            "trainingStatus",
                            "costSettlement",
                            "courseCode",
                            "offeringNo",
                            "organization",
                        ],
                        [
                            "transactionTime",
                            "abstract",
                            "trainingStatus",
                            "settlementAmount",
                            "courseCode",
                            "offeringNo",
                            "organization",
                        ],
                        [
                            "transactionTime",
                            "abstract",
                            "trainingStatus",
                            "costSettlement",
                            "billingMonth",
                            "invoiceNo",
                            "courierNumber",
                            "courseCode",
                            "offeringNo",
                            "organization",
                        ],
                        [
                            "transactionTime",
                            "abstract",
                            "trainingStatus",
                            "costSettlement",
                            "billingMonth",
                            "invoiceNo",
                            "courierNumber",
                            "courseCode",
                            "offeringNo",
                            "organization",
                        ],
                        [
                            "transactionTime",
                            "abstract",
                            "trainingStatus",
                            "refund",
                            "courseCode",
                            "offeringNo",
                            "organization",
                        ],
                    ][this.dataForm.queryType - 1];
                    let temp = keys.map((item) => {
                        return this.tableTitles[item];
                    });
                    return temp;
                } else {
                    return Object.values(this.tableTitles);
                }
            },
        },
        methods: {

    //             handleClose(done) {
    //     this.$confirm('确认关闭？')
    //       .then(_ => {
    //         done();
    //       })
    //       .catch(_ => {});
    //   },


            statusFormatter(trainingStatus) {
                return Vue.filter("coverEnum")(trainingStatus, "training_status");
            },
            init() {
                if (this.$route.params) {
                    this.info = this.$route.params.row;
                    this.dataForm.accountId = this.info.id;
                    if (this.$route.params.date && this.$route.params.date.length === 2) {
                        this.recordTime = this.$route.params.date;
                        this.dataForm.recordTimeS = this.recordTime[0];
                        this.dataForm.recordTimeE = this.recordTime[1];
                    } else {
                        this.initDate();
                    }
                    this.getOrgList();
                }
                this.dataForm.exportType = this.$route.params.type;
                this.getDataListMerge();
            },
            getPickDate(pick) {
                this.pickDate = pick;
            },
            disabledDate(date) {
                const {minDate, maxDate} = this.pickDate;
                if (minDate && !maxDate) {
                    const diff = Math.abs(minDate.valueOf() - date.valueOf());
                    if (diff > 1000 * 3600 * 24 * 365) {
                        return true;
                    }
                }
            },
            // 获取主表信息
            getMasterData() {
                this.dataListLoading = true;
                this.$request
                    .get("/finance/financeaccount/pageall", {
                        nameCn: this.info.nscNo,
                    })
                    .then((res, total, code, data) => {
                        const [temp, info] = res.records;
                        this.info = info;
                        console.log(info, 88888888);

                        this.dataListLoading = false;
                    })
                    .catch(() => {
                        this.dataListLoading = false;
                    });
            },
            // 获取所属组织值列表
            getOrgList() {
                this.dataListLoading = true;
                this.$request
                    .get("/finance/financeaccount/getOrgListByMainCode", {
                        orgCode: this.info.orgCode,
                    })
                    .then((res, total, code, data) => {
                        this.dataListLoading = false;
                        this.organizationList = res.filter((item) => {
                            return item;
                        });
                        this.organizationList.splice(0, 0, {
                            orgCode: "",
                            nameCn: "全部",
                        });
                    })
                    .catch(() => {
                        this.dataListLoading = false;
                    });
            },
            // 获取数据合计
            getDataTotal() {
                let newDataForm = JSON.parse(JSON.stringify(this.dataForm));
                if ("regionIds" in newDataForm) {
                    if (newDataForm.regionIds.length === 0) {
                        newDataForm.regionIds = "";
                    } else {
                        newDataForm.regionIds = newDataForm.regionIds.join(",");
                    }
                }
                this.dataListLoading = true;
                this.$request
                    .get("/finance/financeaccountrecord/pagecustomsum", {
                        ...newDataForm,
                    })
                    .then((res, total, code, data) => {
                        this.dataListLoading = false;
                        this.totalValue = this.transferTotalValue(res);
                        console.log(res, "res");
                    })
                    .catch(() => {
                        this.dataListLoading = false;
                    });
            },
            // 转化totalValue
            transferTotalValue(value) {
                // value = '期初账户余额：0.00;当期资金存储：445,100.00;当期结算费用：26,100.00;期末账户余额：419,000.00'
                let temp = value.split(';')
                let arr = [];
                if (temp.length) {
                    temp.forEach(item => {
                        arr.push(item.split('：'))
                    })
                }
                let str = ''
                arr.forEach((val, index) => {
                    if (index + 1 == arr.length) {
                        str += `<div class="action-left-item">${arr[index][0]}：<span>${arr[index][1]}</span></div>`
                    } else {
                        str += `<div class="action-left-item">${arr[index][0]}：<span>${arr[index][1]}</span></div>
            <div class="action-item-border"></div>`
                    }

                })
                return str;
                // return `<div class="action-left-item">${arr[0][0]}：<span>${arr[0][1]}</span></div>
                //     <div class="action-item-border"></div>
                //     <div class="action-left-item">${arr[1][0]}：<span>${arr[1][1]}</span></div>
                //     <div class="action-item-border"></div>
                //     <div class="action-left-item">${arr[2][0]}：<span>${arr[2][1]}</span></div>
                //     <div class="action-item-border"></div>
                //     <div class="action-left-item">${arr[3][0]}：<span>${arr[3][1]}</span></div>`
            },
            // 查询结果修改事件
            queryTypeChange() {
                if (this.dataForm.queryType === null) {
                    this.dataForm.queryType = "";
                }
                this.tableShow = false;
                this.$nextTick(() => {
                    this.tableShow = true;
                    var query=this.dataForm.queryType;
                    //重置表单数据
                    this.dataForm.accountId=this.info.id;
                    this.dataForm.queryType=0; // 结果类型
                    this.dataForm.courseName=""; // 课程名称
                    this.dataForm.trainingStartDateS=""; // 排期开始时间开始
                    this.dataForm.trainingStartDateE=""; // 排期开始时间结束
                    this.dataForm.trainingEndDateS=""; // 排期结束时间开始
                    this.dataForm.trainingEndDateE=""; // 排期结束时间结束
                    this.dataForm.bizOrgCode= ""; // 组织
                    this.dataForm.invoiceMonth=""; // 开票月份
                    this.dataForm.offeringNo=""; // 排期编号
                    this.dataForm.userKey="";
                    if (!(this.dataForm.recordTimeS.length>0&&this.dataForm.recordTimeE.length>0)){
                        this.dataForm.recordTimeS=""; //交易时间开始
                        this.dataForm.recordTimeE="";//交易时间结束
                        this.initDate();
                    }
                    this.changeFromDisabled();
                    this.trainingStartDate = []; // 排期开始时间
                    this.trainingEndDate = [];
                    this.page = 1;
                    //查询方法
                    this.changeFromDisabled(query);
                    this.dataForm.queryType=query;
                    this.getDataListMerge();
            }
    )
    ;
    },
    // 修改搜索条件是否可输入
    changeFromDisabled(type)
    {
        if (type === 1) {
            this.fromDisabled = {
                offeringNo: true,
                courseName: true,
                recordTime: false,
                trainingStartDate: true,
                trainingEndDate: true,
                bizOrgCode: true,
                invoiceMonth: true,
                userKey: true,
            };
            // this.initDate();
            this.dataForm.courseName = "";
            this.dataForm.offeringNo = "";
            this.dataForm.trainingStartDateS = "";
            this.dataForm.trainingStartDateE = "";
            this.trainingStartDate = [];
            this.dataForm.trainingEndDateS = "";
            this.dataForm.trainingEndDateE = "";
            this.trainingEndDate = [];
            this.dataForm.bizOrgCode = "";
            this.dataForm.invoiceMonth = "";
            this.dataForm.userKey = "";
        }else if(type === 3){
            this.fromDisabled = {
                offeringNo: false,
                courseName: false,
                recordTime: true,
                trainingStartDate: false,
                trainingEndDate: false,
                bizOrgCode: false,
                userKey: false,
                invoiceMonth: true,
            };
            // this.initDate();
            this.recordTime=[];
            this.dataForm.invoiceMonth = "";
            this.dataForm.recordTimeS="";
            this.dataForm.recordTimeE=this.timereversal(new Date());
        }
        else if (type === 6) {
            this.fromDisabled = {
                offeringNo: false,
                courseName: false,
                recordTime: false,
                trainingStartDate: false,
                trainingEndDate: false,
                bizOrgCode: false,
                userKey: false,
                invoiceMonth: true,
            };
            this.dataForm.invoiceMonth = "";
            // this.dataForm.trainingStartDateS = '';
            // this.dataForm.trainingStartDateE = '';
            // this.trainingStartDate = [];
            // this.dataForm.trainingEndDateS = '';
            // this.dataForm.trainingEndDateE = '';
            // this.trainingEndDate = [];
            // this.initDate();
        } else if (type === 5) {
            this.fromDisabled = {
                offeringNo: false,
                courseName: false,
                recordTime: false,
                trainingStartDate: false,
                trainingEndDate: false,
                bizOrgCode: false,
                userKey: false,
                invoiceMonth: true,
            };
            // this.dataForm.courseName = '';
            // this.dataForm.offeringNo = '';
            // this.dataForm.recordTimeS = '';
            // this.dataForm.recordTimeE = '';
            // this.recordTime = [];
            // this.dataForm.trainingStartDateS = '';
            // this.dataForm.trainingStartDateE = '';
            // this.trainingStartDate = [];
            // this.dataForm.trainingEndDateS = '';
            // this.dataForm.trainingEndDateE = '';
            // this.trainingEndDate = [];
            // this.dataForm.bizOrgCode = '';
            this.dataForm.invoiceMonth = "";
        } else {
            this.fromDisabled = {
                offeringNo: false,
                courseName: false,
                recordTime: false,
                trainingStartDate: false,
                trainingEndDate: false,
                bizOrgCode: false,
                userKey: false,
                invoiceMonth: false,
            };
            // this.dataForm.trainingStartDateS = '';
            // this.dataForm.trainingStartDateE = '';
            // this.trainingStartDate = [];
            // this.dataForm.trainingEndDateS = '';
            // this.dataForm.trainingEndDateE = '';
            // this.trainingEndDate = [];
            // this.initDate();
        }
    }
    ,
    // 排期结束时间修改
    trainingEndDateChange()
    {
        if (this.trainingEndDate && this.trainingEndDate.length > 1) {
            this.dataForm.trainingEndDateS = this.trainingEndDate[0];
            this.dataForm.trainingEndDateE = this.trainingEndDate[1];
            this.dataForm.recordTimeS = "";
            this.dataForm.recordTimeE = "";
            this.recordTime = [];
        } else {
            this.dataForm.trainingEndDateS = "";
            this.dataForm.trainingEndDateE = "";
            if (
                this.trainingStartDate == null ||
                this.trainingStartDate.length < 1
            ) {
                //this.initDate()
                // 交易置空并且接触禁用
                this.recordTime = [];
                this.dataForm.recordTimeS = "";
                this.dataForm.recordTimeE = "";
            }
        }
    }
    ,
    // 排期开始时间修改
    trainingStartDateChange()
    {
        if (this.trainingStartDate && this.trainingStartDate.length > 1) {
            this.dataForm.trainingStartDateS = this.trainingStartDate[0];
            this.dataForm.trainingStartDateE = this.trainingStartDate[1];
            this.dataForm.recordTimeS = "";
            this.dataForm.recordTimeE = "";
            this.recordTime = [];
        } else {
            this.dataForm.trainingStartDateS = "";
            this.dataForm.trainingStartDateE = "";
            if (this.trainingEndDate == null || this.trainingEndDate.length < 1) {
                // this.initDate()
                // 交易置空并且接触禁用
                this.recordTime = [];
                this.dataForm.recordTimeS = "";
                this.dataForm.recordTimeE = "";
            }
        }
    }
    ,
    // 交易时间修改
    recordTimeChange()
    {
        if (this.recordTime && this.recordTime.length > 1) {
            this.dataForm.recordTimeS = this.recordTime[0];
            this.dataForm.recordTimeE = this.recordTime[1];
        } else {
            this.dataForm.recordTimeS = "";
            this.dataForm.recordTimeE = "";
        }
    }
    ,
    arraySpanMethod({row, column, rowIndex, columnIndex})
    {
        // if (rowIndex === 0) {
        //     if (columnIndex === 0) {
        //         return [1, this.tableShowTitles.length+1];
        //     } else {
        //         return [0, 0];
        //     }
        // }
        return [1, 1];
    }
    ,
    // 查询
    getDataListMerge()
    {
        console.log(this.dataForm.queryType, 6666);
        if (this.dataForm.queryType === 3) {
            this.page = 1;
            this.getDataList();
            this.getDataTotal();
            this.getMasterData();
            return;
        }
        if (
            this.dataForm.queryType !== 5 &&
            this.dataForm.recordTimeS.length < 1 &&
            this.dataForm.recordTimeE.length < 1 &&
            this.dataForm.trainingStartDateS.length < 1 &&
            this.dataForm.trainingStartDateE.length < 1 &&
            this.dataForm.trainingEndDateS.length < 1 &&
            this.dataForm.trainingEndDateE.length < 1 &&
            (this.dataForm.invoiceMonth == null || this.dataForm.invoiceMonth == "")
        ) {
            return this.$message({
                message: "请选择开始时间和结束时间",
                type: "error",
                duration: 2000,
            });
        }
        this.page = 1;
        this.getDataList();
        this.getDataTotal();
        this.getMasterData();
    }
    ,

    // 重置
    again()
    {
        this.dataForm = {
            accountId: this.info.id,
            queryType: 0, // 结果类型
            courseName: "", // 课程名称
            recordTimeS: "", //交易时间开始
            recordTimeE: "", //交易时间结束
            trainingStartDateS: "", // 排期开始时间开始
            trainingStartDateE: "", // 排期开始时间结束
            trainingEndDateS: "", // 排期结束时间开始
            trainingEndDateE: "", // 排期结束时间结束
            bizOrgCode: "", // 组织
            invoiceMonth: "", // 开票月份
            offeringNo: "", // 排期编号
            userKey: "",
            exportType: this.dataForm.exportType,
        };
        this.initDate();
        this.changeFromDisabled();
        this.trainingStartDate = []; // 排期开始时间
        this.trainingEndDate = [];
        this.page = 1;
        this.getDataList();
        this.getDataTotal();
    }
    ,
    // 搜索条件展开事件
    openAction(val)
    {
        this.isOpen = val;
    }
    ,
    // 返回事件
    goback()
    {
        if (this.dataForm.exportType === "orgManagerUserType") {
            this.$router.push({
                name: "charge-rainingFeeQuery-distributor",
                params: {},
            });
        } else {
            this.$router.push({
                name: "charge-rainingFeeQuery-index",
                params: {},
            });
        }
    }
    ,
    setCellStyle({row, column, rowIndex, columnIndex})
    {
        // if (rowIndex === 0) {
        //     if (columnIndex === 0) {
        //         return "font-weight: bold; padding:0px;";
        //     }
        // }
        return "padding:0px;";
    }
    ,
    initDate()
    {
        let nowDate = this.timereversal(new Date());
        let monthBefore = this.getYearFirstDay(nowDate);
        this.recordTime = [monthBefore, nowDate];
        this.dataForm.recordTimeS = monthBefore;
        this.dataForm.recordTimeE = nowDate;
    }
    ,
    //传入一个date对象然后调用该方法
    timereversal(Time)
    {
        // var Time = new Date(parseInt(date.slice(6)), 10);//解析date并返回一个整数。
        var y = Time.getFullYear(); //年
        var m = Time.getMonth() + 1; //月
        m = m < 10 ? "0" + m : m;
        var d = Time.getDate(); //日
        d = d < 10 ? "0" + d : d;
        var h = Time.getHours(); //时
        var minute = Time.getMinutes(); //分
        minute = minute < 10 ? "0" + minute : minute;
        var Seconds = Time.getSeconds(); //秒
        return y + "-" + m + "-" + d;
    }
    ,
    //获取1月1日的日期
    //入参格式：YYYY-MM-DD
    getYearFirstDay(date)
    {
        var arr = date.split("-");
        var year = arr[0]; //当前年
        var pre_month_day = year + "-01-01";
        return pre_month_day;
    }
    ,
    //获取前一个月的日期
    //入参格式：YYYY-MM-DD
    getPreMonthDay(date)
    {
        var arr = date.split("-");
        var year = arr[0]; //当前年
        var month = arr[1]; //当前月
        var day = arr[2]; //当前日
        //验证日期格式为YYYY-MM-DD
        var reg = date.match(/^[0-9]{4}-[0-9]{1,2}-[0-9]{1,2}$/);
        if (!reg || month > 12 || day > 31) {
            console.log("日期或格式有误！请输入正确的日期格式（年-月-日）");
            return;
        }

        var pre_year = year; //前一个月的年
        var pre_month = parseInt(month, 10) - 1; //前一个月的月，以下几行是上月数值特殊处理
        if (pre_month === 0) {
            pre_year = parseInt(pre_year, 10) - 1;
            pre_month = 12;
        }
        var pre_day = parseInt(day, 10); //前一个月的日，以下几行是特殊处理前一个月总天数
        var pre_month_alldays = new Date(pre_year, pre_month, 0).getDate(); //巧妙处理，返回某个月的总天数
        if (pre_day > pre_month_alldays) {
            pre_day = pre_month_alldays;
        }
        if (pre_month < 10) {
            //补0
            pre_month = "0" + pre_month;
        } else if (pre_day < 10) {
            //补0
            pre_day = "0" + pre_day;
        }

        // var pre_month_day = pre_year + "-" + pre_month + "-" + pre_day;
        // 获取一月一日
        var pre_month_day = pre_year + "-" + "01" + "-" + "01";
        return pre_month_day;
    }
    ,
    /**
     * 将数值四舍五入(保留2位小数)后格式化成金额形式
     *
     * @param num 数值(Number或者String)
     * @return 金额格式的字符串,如'1,234,567.45'
     * @type String
     */
    formatMoney(num)
    {
        if (!num && num !== 0 && num !== "0") {
            return "";
        }
        num = num.toString().replace(/\$|\,/g, "");
        if (isNaN(num)) {
            num = "0";
        }
        let sign = num == (num = Math.abs(num));
        num = Math.floor(num * 100 + 0.50000000001);
        let cents = num % 100;
        num = Math.floor(num / 100).toString();
        if (cents < 10) {
            cents = "0" + cents;
        }
        for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
            num =
                num.substring(0, num.length - (4 * i + 3)) +
                "," +
                num.substring(num.length - (4 * i + 3));
        }
        return (sign ? "" : "-") + num + "." + cents;
    }
    ,
            //导出方法
            exportPost() {
                let params = {
                    'token': this.getStorage(this.GLOBAL.TOKEN),
                    ...this.dataForm
                };
                //值为数字的要替换成字符串，不然后台报错
                params.queryType+="";
                this.$request.downloadByPost7(this.mixinViewModuleOptions.exportURL,'经销商培训辅导费用交易明细', params, null)
            }
        },
    }
    ;
</script>
<style lang="scss" scoped>
    @import "../../../css/pkg-styles.css";
    @import "../../../../assets/scss/modules/trainingCharge.scss";
    .el-dialog__body{
        overflow: auto;
    }
    .el-icon-warning{
        font-size: 25px;
        width: 25px;
        height: 25px;
    }
   .el-dialog__footer{
        height: 60px;
   }
    .dialog-footer{
       padding: 20px !important;

    }
    .el-tab-pane{
        width: 1060px;
    }

    .aui-wrapper .el-date-editor .el-range-separator {
        width: 30px;
    }

    .jieshu .el-form-item__content {
        width: 94.5%;
    }

    .kaishi .el-form-item__content {
        width: 111%;
    }

    .el-row {
        margin-bottom: 0px;
    }

    #container {
        display: -webkit-flex;
    }

    .el-date-editor.el-input {
        width: 150px;
    }

    .search-item {
        width: 94% !important;
        min-width: 290px;
    }

    // .search {
    //     //   height: 80px;
    // }

    .wrapper-div {
        .el-dialog__title {
            text-align: center;
            display: block;
        }
    }

    .grid-content {
        border-radius: 4px;
        min-height: 36px;
    }

     .search-item .el-form-item__content {
        margin-left: 96px !important;
    }

    .info-sub-titlte {
        font-weight: bold;
        font-style: normal;
        font-size: 17px;
        color: #333333;
        margin: 15px;
        display: block;
    }

    .info-sub-value {
        font-weight: 700;
        font-style: normal;
        font-size: 25px;
        color: #165cd5;
        margin: 15px;
        display: block;
        text-align: left;
    }

    // .margb10 {
    //   min-height: 75px;
    // }
    .mod-joylearning__offringlist {
        padding: 9px;


        .pkg-content-top {

            .info-title {
                font-weight: 700;
                font-style: normal;
                color: rgba(37, 38, 40, 100);
                font-size: 18px;
                height: 18px;
                font-family: BMWGlobalProLight, sans-serif;
            }


            .pkg-content-row {
                margin-top: -10px;
                padding:25px;
                word-wrap:break-word;
                margin-bottom: -15px;
                .content-row-item {
                      overflow: hidden;
                        text-overflow: ellipsis;
                    white-space: nowrap;
                    display: flex;
                    width: calc((100% - 48px) / 3) !important;
                    // height: 137px;
                    min-height: 124px;
                    border-radius: 6px;
                    background-color: rgba(255, 255, 255, 1);
                    padding: 5px 3px;


                    &:nth-child(2) {
                        margin: 0 24px;
                    }

                    .row-item-left {
                        width: 52px;
                        height: 52px;
                        border-radius: 21px;
                        flex-shrink: 0;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .row-item-right {
                        padding-left: 10px;
                        word-wrap:break-word;
                        .row-item-right-title {
                            color: rgba(37, 38, 40, 100);
                            font-size: 16px;
                            font-family: BMWGlobalProLight, sans-serif;
                            // height: 22px;
                            line-height: 22px;
                        }

                        .row-item-right-money {

                            color: rgba(37, 38, 40, 100);
                            font-size: 28px;
                            font-family: BMWGlobalProBold, sans-serif;
                            height: 50px;
                            line-height: 50px;
                            // margin-bottom: 8px;
                        }

                        .row-item-right-tip {
                            color: rgba(153, 154, 156, 100);
                            font-size: 12px;
                            // height: 16px;
                            line-height: 16px;
                            font-family: BMWGlobalProReg, sans-serif;
                        }
                    }
                }
            }


        }

        .action {
            margin: 10px 0 !important;
        }

         .action-left {
            display: flex;
            // overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

      .action-left-item:last-child{
                 flex: 1;
              overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;


      }

            .action-left-item {
                 margin-left: 15px;
                display: inline-block;
                height: 20px;
                line-height: 20px;
                color: rgba(37, 38, 40, 100);
                font-size: 14px;
                font-family: BMWGlobalProReg, sans-serif;
                padding: 0 16px;


                &:nth-child(1) {
                    padding-left: 0px;
                }


                > span {
                    color: rgba(37, 38, 40, 100);
                    font-family: BMWGlobalProBold, sans-serif;
                    font-weight: bold;
                }
            }

            .action-item-border {
                width: 1px;
                margin-top: 5px;
                height: 10px;
                display: inline-block;
                background-color: rgba(109, 110, 112, 1);
            }
        }
    }

    .label-tip {
        line-height: 20px;
        // margin-left:0px!important;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

     .el-button {
        font-weight: 500 !important;
    }
    .btnColorBlack{
        color: black!important;
    }
</style>
<style>
    .date-style-rfq .el-date-range-picker__time-header {
        display: none;
    }

    .el-tabs__content {
        padding-top: 0px !important;
    }

</style>
